// Возвращает классы бейджа по типу периода (как в турнирах).
export function getTypeBadgeClasses(type) {
    switch (type) {
        case "daily":
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
        case "weekly":
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
        case "monthly":
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
        default:
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
    }
}

// Возвращает светлый вариант бейджа времени окончания турнира.
export function getTournamentTimeBadgeClasses(type) {
    switch (type) {
        case "daily":
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
        case "weekly":
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
        case "monthly":
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
        default:
            return "arcade-badge text-xs whitespace-nowrap flex-shrink-0";
    }
}
